export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  LOGOUT: '/logout',

  DASHBOARD: '/dashboard',
  DEVICES: '/dashboard/devices',
  DEVICE_ADD: '/dashboard/devices/add',
  DEVICE_DETAIL: '/dashboard/devices/:did',
  DEVICE_EDIT: '/dashboard/devices/:did/edit',

  APPLICATIONS: '/dashboard/applications',
  APPLICATION_ADD: '/dashboard/applications/add',
  APPLICATION_ADD_DEVICE: '/dashboard/applications/add-device',
  APPLICATION_DETAIL: '/dashboard/applications/:aid',
  APPLICATION_EDIT: '/dashboard/applications/:aid/edit',
  APPLICATION_SHARE: '/dashboard/applications/share',

  GATEWAYS: '/dashboard/gateways',
  GATEWAY_ADD: '/dashboard/gateways/add',
  GATEWAY_DETAIL: '/dashboard/gateways/:gid',
  GATEWAY_EDIT: '/dashboard/gateways/:gid/edit',
  GATEWAY_POWEROFF: '/dashboard/gateways/:gid/poweroff-history',
  GATEWAY_SPECTRAL: '/dashboard/gateways/:gid/spectral-scan',
  GATEWAY_RNC: '/dashboard/gateways/:gid/rnc',
  GATEWAY_SHARE: '/dashboard/gateways/share',

  GATEWAY_PROFILES: '/dashboard/gateway-profiles',
  GATEWAY_PROFILE_ADD: '/dashboard/gateway-profiles/add',
  GATEWAY_PROFILE_DETAIL: '/dashboard/gateway-profiles/:gpid',
  GATEWAY_PROFILE_EDIT: '/dashboard/gateway-profiles/:gpid/edit',

  MULTICAST: '/dashboard/multicast',
  MULTICAST_ADD: '/dashboard/multicast/add',
  MULTICAST_DETAIL: '/dashboard/multicast/:mgid',
  MULTICAST_EDIT: '/dashboard/multicast/:mgid/edit',

  USERS: '/dashboard/users',
  USER_ADD: '/dashboard/users/add',
  USER_DETAIL: '/dashboard/users/:uid',
  USER_EDIT: '/dashboard/users/:uid/edit',

  USER_PROFILES: '/dashboard/user-profiles',
  USER_PROFILE_ADD: '/dashboard/user-profiles/add',
  USER_PROFILE_DETAIL: '/dashboard/user-profiles/:upid',
  USER_PROFILE_EDIT: '/dashboard/user-profiles/:upid/edit',

  PROFILE: '/dashboard/profile',
  CHANGE_PASSWORD: '/dashboard/change-password',
  CONSOLE: '/dashboard/console',
  STATISTICS: '/dashboard/statistics',
  AI: '/dashboard/ai',
  IMPORT_STATUS: '/dashboard/import/:entity/:id',
  DOCS: '/dashboard/docs',
} as const;

export const buildRoute = (
  route: string,
  params: Record<string, string | number>,
): string => {
  return Object.entries(params).reduce(
    (path, [key, value]) => path.replace(`:${key}`, String(value)),
    route,
  );
};
